import React, { useContext } from 'react'
import { PlanChangeContext } from 'components/Shared/TrialWarning/PlanChangeContext'
import useOrderSummaryData from '../hooks/useOrderSummaryData'
import PlanRenewal from './PlanRenewal'
import SwitchToYearlyButton from './SwitchToYearlyButton'
import AddonsOverage from './AddonsOverage'

const OrderSummary = ({
  planName,
  coupon,
  submitting,
  onToggle,
  renderCoupon,
  updatePaymentSettings,
  isRegionalDiscount,
}) => {
  const {
    additionalPublishedApps,
    additionalTeamMembers,
    publishedAppsOverageAmount,
    teamMembersOverageAmount,
  } = useContext(PlanChangeContext)

  const addons = {
    additionalPublishedApps,
    additionalTeamMembers,
    publishedAppsOverageAmount,
    teamMembersOverageAmount,
  }

  const { plan, priceAdjustments, billing } = useOrderSummaryData({
    planName,
    updatePaymentSettings,
    coupon,
  })
  const { isAnnual, yearlySavings } = plan
  const { proratedNetAmount, amountOff } = priceAdjustments
  const { planCost } = billing

  return (
    <div className="order-summary">
      <div className="order-summary-header">Order Summary</div>
      <div className="order-summary-content">
        <div className="left">{plan.name}</div>
        <div className="right">${plan.initialCost.toLocaleString('en-US')}</div>
        {isAnnual ? (
          <>
            <div className="clear-left left">Yearly Savings</div>
            <div className="clear-right right">
              {yearlySavings.toLocaleString('en-US')}
            </div>
          </>
        ) : null}
        {proratedNetAmount ? (
          <div>
            <div className="clear-left left">Prorated adjustment</div>
            <div className="clear-right right">
              {proratedNetAmount.toLocaleString('en-US')}
            </div>
          </div>
        ) : null}
        <AddonsOverage addons={addons} />
        {amountOff ? (
          <>
            <div className="clear-left left">
              {isRegionalDiscount ? 'Regional Discount' : 'Promotion Savings'}
            </div>
            <div className="clear-right right">
              -${amountOff.toLocaleString('en-US')}
            </div>
          </>
        ) : null}
        {renderCoupon()}
      </div>
      <div className="order-summary-footer">
        <div className="clear-left left">
          <h2>Total</h2>
        </div>
        <div className="clear-right right">
          <h2>${planCost.toLocaleString('en-US')}</h2>
        </div>
      </div>
      <PlanRenewal isAnnual={isAnnual} addons={addons} billing={billing} />
      <SwitchToYearlyButton
        planType={plan.name}
        isAnnual={isAnnual}
        submitting={submitting}
        onToggle={onToggle}
      />
    </div>
  )
}

export default OrderSummary
